// extracted by mini-css-extract-plugin
export var progressBar = "_iz-0";
export var progressBarInner = "_iz-1";